import { render, staticRenderFns } from "./TrackerNotificationsSettings.vue?vue&type=template&id=6d68aaa7&scoped=true&"
import script from "./TrackerNotificationsSettings.vue?vue&type=script&lang=js&"
export * from "./TrackerNotificationsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d68aaa7",
  null
  
)

export default component.exports